import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';

import CommonUiIcon from 'webapp/components/common/ui-icon';
import SubmitButton, { IconPosition } from 'webapp/components/submit-button';

interface CustomQuerySetupWizardSheetControlsComponentInterface {
	Args: {
		showBack: boolean;
		isButtonDisabled: boolean;
		goNext: () => void;
		goPrevious: () => void;
		isButtonHidden?: boolean;
		submitInProgress?: boolean;
	};
}

const CustomQuerySetupWizardSheetControlsComponent: TOC<CustomQuerySetupWizardSheetControlsComponentInterface> =
	<template>
		{{#unless @isButtonHidden}}
			<SubmitButton
				@text="Continue"
				@icon="ArrowRight"
				@iconPosition={{IconPosition.AFTER}}
				@extraClass="next"
				@size="big"
				@isDisabled={{@isButtonDisabled}}
				@submitInProgress={{@submitInProgress}}
				@noDelay={{true}}
				@onTrigger={{@goNext}}
			/>
		{{/unless}}

		{{#if @showBack}}
			<a role="button" class="btn back" {{on "click" @goPrevious}}>
				<CommonUiIcon @name="ArrowLeft" @size="xs" />Go back
			</a>
		{{/if}}
	</template>;

export default CustomQuerySetupWizardSheetControlsComponent;
